import Player from '@vimeo/player';

const init = () => {
    document.querySelectorAll(".ns-video-player__container").forEach((item) => {
        item.addEventListener("click", function (e) {
            const iframe = e.currentTarget.querySelector(".ns-video-player__iframe");
            e.currentTarget.classList.add("activated");
            const player = new Player(iframe);
            player.play();
        })
    });
}
function iframeResizeOnWindowResize(){
    document.querySelectorAll(".ns-video-player__iframe").forEach((iframe) => {
        resizeIframe(iframe);
    });
}
function resizeIframe(iframe){
    const ratio = iframe.dataset.ratio ? iframe.dataset.ratio : 1.777;
    const currentWidth = iframe.scrollWidth;
    iframe.height = currentWidth / ratio;
}
document.querySelectorAll(".ns-video-player__iframe").forEach((iframe) => {
    resizeIframe(iframe);
});
window.addEventListener("DOMContentLoaded", init, false);
window.addEventListener("resize", iframeResizeOnWindowResize, false);
